import * as React from 'react';
import { useDeviceCondition } from '../../../../../../../../hooks';
import * as styles from './ErrorWrapper.css';
import classNames from 'classnames';
import { Shimmer } from '../../../../../../../common/Shimmer';

interface IErrorWrapperProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  loading?: boolean;
}

export const ErrorWrapper = ({ icon, children, loading = false }: IErrorWrapperProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <Shimmer theme="orange" running={loading}>
      <div className={classNames(rootStyle, styles['wrapper'])}>
        <div className={styles['icon']}>{icon}</div>
        <div className={styles['children']}>{children}</div>
      </div>
    </Shimmer>
  );
};
